// permission-policy.js

// Fields that users can edit on their own profile
export const SELF_EDITABLE_USER_FIELDS = [
  "x",
  "linkedin",
  "website",
  "emoji",
  "avatar",
  "secondary_job_title",
];

export const PERMISSION_POLICY = {
  employees: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  projects: {
    create: {
      requiresCoordinator: false, // sales person with permission can create
      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
      // coordinatorTypes: ["PC", "SC"],
    },
  },
  jobs: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    read: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  job_extensions: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    update:{
      requiresCoordinator: true,
    }
  },
  allocated_hours: {
    create: {
      requiresCoordinator: true,

      allowedRoles: ["Admin", "FIN"],
    },
  },
  jobs_employees: {
    create: {
      requiresCoordinator: true,

      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    delete: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  dedicated_job_config: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    read: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  dedicated_job_config: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    read: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  hourly_job_config: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    read: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  bucket_job_config: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    read: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  recurring_job_config: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    read: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  billables: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
  },
  billable_chats: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "SC", "AM", "FIN"],
    },
  },
  billable_extensions: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "SC", "AM", "FIN"],
    },
  },
  milestones: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN", "AM"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN", "AM"],
    },
  },
  projects__integrations: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
  },
  bookmark_links: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
  },
  hourly_billing_config: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "SC", "FIN"],
    },
  },
  dedicated_billing_config: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "SC", "FIN"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "SC", "FIN"],
    },
  },
  fixed_billing_config: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "SC", "FIN"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "SC", "FIN"],
    },
  },
  tickets: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  case_studies: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  legal_entities: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    delete: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  assets: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  performance_review: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "HRM"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "HRM"],
    },
    delete: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "HRM"],
    },
  },
  performance_review_months: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "HRM"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "HRM"],
    },
    delete: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "HRM"],
    },
  },
  directus_comments: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  interviews: {
    create: {
      requiresCoordinator: false,
      // allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      // allowedRoles: ["Admin"],
    },
    delete: {
      requiresCoordinator: false,
      // allowedRoles: ["Admin"],
    },
  },
  calendar_events: {
    create: {
      requiresCoordinator: false,
      // allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      // allowedRoles: ["Admin"],
    },
    delete: {
      requiresCoordinator: false,
      // allowedRoles: ["Admin"],
    },
  },
  customer_satisfaction: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "AM"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "AM"],
    },
  },
  surveys: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "AM"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "AM"],
    },
  },
  contracts: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
    delete: {
      requiresCoordinator: true,
      allowedRoles: ["Admin"],
    },
  },
  clients: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  companies: {
    create: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: true,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  pull_requests: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  departments: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  holidays: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  currencies: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  countries: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  job_titles: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  grades: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  skills: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  functions: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  cost_masters: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "FIN"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  tags: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "FIN"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "FIN"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin", "FIN"],
    },
  },
  survey_categories: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
  survey_questions: {
    create: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    update: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
    read: {
      requiresCoordinator: false,
      allowedRoles: ["Admin"],
    },
  },
};
